import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Wrapper, Info, Status, LinkStyled, Sorry} from './NotFound.style';

const NotFound = () => {
    return (
      <Wrapper>
        <Info><FormattedMessage id="notFound.info1" /></Info>
        <Status>404</Status>
        <Sorry>Sorry</Sorry>
        <Info>
          <FormattedMessage
            id="notFound.info2"
            values={{
              menu: (
                  <LinkStyled to="/menu">
                    <FormattedMessage id="notFound.menu" />
                  </LinkStyled>
                ),
              homepage: (
                <LinkStyled to="/">
                  <FormattedMessage id="notFound.homepage" />
                </LinkStyled>
              )
            }}
          />
        </Info>
      </Wrapper>
    );
};

export default NotFound;



// WEBPACK FOOTER //
// ./containers/NotFound/NotFound.js